import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { EcosystemClassificationType } from '@/api/rest/resources/types/ecosystemClassification';
import { PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import { DonutChart } from '@/components/Charts/DonutChart';
import {
  getIucnGetLevelThreeEFGLegendValues,
  getIucnGetLevelTwoBiomeLegendValues,
} from '@/components/widgets/o/Map/utils/getLegends';
import { getGraphDataFromGraphFacts } from '@/pages/shared/projects/pages/project/pages/sustainableProduction/pages/plot/components/ecosystemClassification/utils';

import { NoPlotData } from '../NoPlotData';

type EcosystemClassificationStatsTileProps = {
  graphFacts: PlotReportFactElement<number | null>[] | undefined;
  category: EcosystemClassificationType;
};

export const EcosystemClassificationGraphTile = ({ graphFacts, category }: EcosystemClassificationStatsTileProps) => {
  const { t } = useTranslation();

  const graphFactsLabel = t(`shared.ncaDetail.ecosystemClassification.${category}.labels.graphFact`);
  const graphFactsTooltipLabel = t(`shared.ncaDetail.ecosystemClassification.${category}.labels.graphFactTooltip`);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const tAny = t as any;
  const colors = [...getIucnGetLevelThreeEFGLegendValues(), ...getIucnGetLevelTwoBiomeLegendValues()].map((color) => ({
    ...color,
    text: tAny(color.text),
  }));
  const chartData = getGraphDataFromGraphFacts(graphFacts, colors);

  if (chartData.length === 0) {
    return <NoPlotData />;
  }

  return (
    <Stack center data-testid='ecosystem-classification-graph-tile'>
      <Stack spacing={2.5} className='w-full items-center justify-center px-1 py-6 lg:items-start lg:p-8 lg:pl-1'>
        <ChartHeading
          heading={graphFactsLabel}
          className='w-full px-6 sm:px-0'
          popover={{
            title: graphFactsLabel,
            body: graphFactsTooltipLabel,
          }}
        />
        <DonutChart data={chartData} />
      </Stack>
    </Stack>
  );
};
